<template>
  <button
    class="search-overlay-toggle"
    type="button"
    @click="toggle"
    :aria-expanded="state.isOpen"
    :aria-controls="state.isOpen ? state.overlayId : undefined"
  >
    <dpc-icon
      class="search-overlay-toggle__icon"
      :icon="state.isOpen ? 'close' : 'search'"
      :label-path="state.isOpen ? 'closeSearch' : 'openSearch'"
    />
  </button>
</template>

<script setup>
import { useSharedState } from '@composables/use-shared-state';

const { state } = useSharedState({ id: 'search-overlay' });

const toggle = () => {
  state.isOpen = !state.isOpen;
};
</script>

<script>
export default {
  compatConfig: {
    ATTR_FALSE_VALUE: false,
  },
};
</script>
